export default "__VITE_ASSET__CUWeqVSc__"